import { NgModule } from "@angular/core";
import { NouisliderModule } from "ng2-nouislider";
import { SearchResultsComponent } from "apps-module/app/entry-modules/vacancies-search/components/search-results/search-results.component";
import { ResultItemComponent } from "apps-module/app/entry-modules/vacancies-search/components/search-results/result-item/result-item.component";
import { VacanciesSearchComponent } from "apps-module/app/entry-modules/vacancies-search/vacancies-search.component";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";

@NgModule({
    declarations: [
        VacanciesSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [VacanciesSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class VacanciesSearchModule { }
